import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const chatApi = {
  start: (visitorId, page, utm, stage, service) =>
    axios.post(`${API}/chat/start`, { visitor_id: visitorId, page, utm, stage, service }).then((r) => r.data),
  send: (cid, text) => axios.post(`${API}/chat/${cid}/message`, { text }).then((r) => r.data),
  poll: (cid) => axios.get(`${API}/chat/${cid}/messages`).then((r) => r.data),
};

const adminHeaders = (code) => ({ headers: { "X-Admin-Code": code } });

export const adminApi = {
  list: (code) => axios.get(`${API}/chat/admin/conversations`, adminHeaders(code)).then((r) => r.data),
  get: (code, cid) =>
    axios.get(`${API}/chat/admin/conversations/${cid}`, adminHeaders(code)).then((r) => r.data),
  reply: (code, cid, text) =>
    axios.post(`${API}/chat/admin/conversations/${cid}/reply`, { text }, adminHeaders(code)).then((r) => r.data),
  handoff: (code, cid) =>
    axios.post(`${API}/chat/admin/conversations/${cid}/handoff`, {}, adminHeaders(code)).then((r) => r.data),
  close: (code, cid) =>
    axios.post(`${API}/chat/admin/conversations/${cid}/close`, {}, adminHeaders(code)).then((r) => r.data),
};

export const leadsApi = {
  list: (code, params) => axios.get(`${API}/leads`, { ...adminHeaders(code), params }).then((r) => r.data),
  stats: (code) => axios.get(`${API}/leads/stats`, adminHeaders(code)).then((r) => r.data),
  update: (code, id, body) => axios.patch(`${API}/leads/${id}`, body, adminHeaders(code)).then((r) => r.data),
  clicks: (code, params) => axios.get(`${API}/whatsapp-clicks`, { ...adminHeaders(code), params }).then((r) => r.data),
};

